/**
 * Locale-aware relative time formatting.
 * Returns "just now" for <60s, relative strings for recent dates,
 * and localized date string for dates older than 30 days.
 */
export function timeAgo(date: string | Date, locale = "en"): string {
  const now = Date.now();
  const then = typeof date === "string" ? new Date(date).getTime() : date.getTime();
  const diff = Math.floor((now - then) / 1000);

  if (diff < 60) return "just now";

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });

  if (diff < 3600) return rtf.format(-Math.floor(diff / 60), "minute");
  if (diff < 86400) return rtf.format(-Math.floor(diff / 3600), "hour");
  if (diff < 604800) return rtf.format(-Math.floor(diff / 86400), "day");
  if (diff < 2592000) return rtf.format(-Math.floor(diff / 604800), "week");

  return new Date(then).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
